import { useIntl } from "react-intl";

const SmartArticleSuggestion = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.SmartArticleSuggestion.header",
            defaultMessage: "Smart article suggestion"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.SmartArticleSuggestion.body",
            defaultMessage:
                "Set up article suggestions that can help your customers as they fill in a request form. Use labels to limit which articles are shown in each form."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default SmartArticleSuggestion;
